import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairing Events at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>All Rosé in May</h1>
                  <h4 className="one">
                    May 20th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                    <br className="fullBr" />
                    Hosted by United Distributors of Alabama
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="sectionWrap insideNrw food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="service-box-2">
              <h3>Passed Appetizers on the Patio</h3>
              <h4>Prosciutto Wrapped Stuffed Shrimp</h4>
              <h5>Smoked Gouda, Cream Cheese, Bell Pepper, Romesco Sauce</h5>
              <p>Paired with</p>
              <h4>Mezy Reserve De Primes Rosé · France '24</h4>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Tuna Carpaccio</h4>
                <h5>Almonds, Red Onion, Lemon, Honey</h5>
                <p>Paired with</p>
                <h4>Ventessa Vigneti delle Dolomiti Pinot Grigio Rosé · Italy '24</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Watermelon Caprese Salad</h4>
                <h5>Fresh Mozzarella, Salami, Lemon Zest, Fresh Basil</h5>
                <p>Paired with</p>
                <h4>Casal Garcia Vinho Verde Rosé · Portugal NV</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Honey Garlic Braised Pork Tenderloin</h4>
                <h5>Forbidden Black Rice, Sorrel, Swiss Chard</h5>
                <p>Paired with</p>
                <h4>A to Z Wineworks Rosé · Oregon '25</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">                
                <h3>Course Four</h3>
                <h4>Panna Cotta with Strawberry Fragole </h4>
                <h5>Strawberry, Blueberry, Raspberry, Mint</h5>
                <p>Paired with</p>
                <h4>A to Z Wineworks Bubbles Rosé · Oregon '00</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
